import { styled } from '@mui/material/styles';
import { ActionButton } from '@/components/buttons';

export const CheckNameContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
});

export const ActionButtonStyled = styled(ActionButton)({
  marginBottom: '10px',
});
